<template>
<div class="page-wrapper">
    <div class="page-body">
        <div class="container-fluid">
            <div class="row row-cards">
                <div class="col-lg-4">
                    <div class="card">
                        <div class="card-header" :tabindex="mobile ? 0 : null" @click="openSelectAvatarCardBody" @keydown.enter.space="openSelectAvatarCardBody">
                          Select an avatar
                        </div>
                        <div class="card-header d-flex flex-column align-items-center">
                          <input type="text" class="form-control mb-2" placeholder="Search" v-model="searchQuery" />
                          <div class="w-100 position-relative">
                            <div
                              tabindex="0"
                              class="form-control dropdown-toggle d-flex align-items-center justify-content-between"
                              data-bs-toggle="dropdown"
                              :class="{'py-1 ps-1': selectedCategoryOptions.length > 0}"
                              style="min-height: 40px; color: #8a97ab;">
                              <span v-if="selectedCategoryOptions.length === 0">
                                Categories
                              </span>
                              <span v-else class="d-flex flex-wrap gap-1">
                                <span
                                  v-for="(categoryOption, i) in selectedCategoryOptions"
                                  :key="i"
                                  class="badge bg-blue-lt d-flex align-items-center gap-2"
                                  style="padding-top: 7px; padding-bottom: 7px;">
                                  {{ categoryOption.value == "AI-generated" ? "AI-influencers" : categoryOption.value }}
                                  <icon
                                    icon="close"
                                    height="14"
                                    class="ms-auto me-0 cursor-pointer"
                                    style="min-width: 0;"
                                    @click.stop.prevent.exact="removeCategoryOption(categoryOption)"/>
                                </span>
                              </span>
                            </div>
                            <div class="dropdown-menu dropdown-menu-scrollable w-100 px-3 py-3">
                              <div>
                                <div class="text-muted mb-3">Main</div>
                                <label v-for="option in mainOptions" :key="option" class="form-check">
                                  <input class="form-check-input" type="checkbox" v-model="main" :value="option" />
                                  <span class="form-check-label">{{ option == "AI-generated" ? "AI-influencers" : option }}</span>
                                </label>
                              </div>
                              <div>
                                <div class="text-muted mb-3">Orientation</div>
                                <label v-for="option in orientationOptions" :key="option" class="form-check">
                                  <input class="form-check-input" type="checkbox" v-model="orientation" :value="option" />
                                  <span class="form-check-label">{{ option }}</span>
                                </label>
                              </div>
                              <div>
                                <div class="text-muted mb-3">Gender</div>
                                <label v-for="option in genderOptions" :key="option" class="form-check">
                                  <input class="form-check-input" type="checkbox" v-model="gender" :value="option" />
                                  <span class="form-check-label">{{ option }}</span>
                                </label>
                              </div>
                              <div>
                                <div class="text-muted mb-3">Age</div>
                                <label v-for="option in ageOptions" :key="option" class="form-check">
                                  <input class="form-check-input" type="checkbox" v-model="age" :value="option" />
                                  <span class="form-check-label">{{ option }}</span>
                                </label>
                              </div>
                              <div>
                                <div class="text-muted mb-3">Ethnicity</div>
                                <label v-for="option in ethnicityOptions" :key="option" class="form-check">
                                  <input class="form-check-input" type="checkbox" v-model="ethnicity" :value="option" />
                                  <span class="form-check-label">{{ option }}</span>
                                </label>
                              </div>
                              <div>
                                <div class="text-muted mb-3">Style</div>
                                <label v-for="option in styleOptions" :key="option" class="form-check">
                                  <input class="form-check-input" type="checkbox" v-model="style" :value="option" />
                                  <span class="form-check-label">{{ option }}</span>
                                </label>
                              </div>
                              <div>
                                <div class="text-muted mb-3">Setting</div>
                                <label v-for="option in settingOptions" :key="option" class="form-check">
                                  <input class="form-check-input" type="checkbox" v-model="setting" :value="option" />
                                  <span class="form-check-label">{{ option }}</span>
                                </label>
                              </div>
                              <div>
                                <div class="text-muted mb-3">Pose</div>
                                <label v-for="option in poseOptions" :key="option" class="form-check">
                                  <input class="form-check-input" type="checkbox" v-model="pose" :value="option" />
                                  <span class="form-check-label">{{ option }}</span>
                                </label>
                              </div>
                              <div>
                                <div class="text-muted mb-3">Occupation</div>
                                <label v-for="option in occupationOptions" :key="option" class="form-check">
                                  <input class="form-check-input" type="checkbox" v-model="occupation" :value="option" />
                                  <span class="form-check-label">{{ option }}</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-show="selectAvatarCardBodyOpen" class="card-body overflow-x-auto" style="height: 85vh">
                            <div class="row row-cards">
                                <div class="col-6" v-for="avatar in filteredAvatars" :key="avatar.id">
                                    <div :class="'card position-relative ' + (selectedAvatarId === avatar.id || (selectedAvatar && selectedAvatar.parent_id === avatar.id) ? 'card-active' : '')" @click.prevent="selectedAvatarId = avatar.id">
                                        <div class="card-body p-0">
                                            <img :src="avatar.image" class="avatar-image"/>
                                        </div>
                                        <div v-if="getAvatarLooks(avatar).length > 1" class="position-absolute avatar-looks">
                                          <div class="badge bg-primary-lt opacity-80 d-flex align-items-center gap-1 cursor-pointer" @click.stop="$refs['avatar-looks-modal'].open(selectedAvatarId, getAvatarLooks(avatar))">
                                            <icon icon="shirt" height="16"></icon>{{ getAvatarLooks(avatar).length }}
                                          </div>
                                        </div>
                                        <div class="position-absolute avatar-name-and-preview-badges">
                                          <div class="badge bg-secondary-lt opacity-80 text-truncate">{{ avatar.name }}</div>
                                          <div v-if="avatar.video_preview_url" class="badge bg-primary-lt opacity-80 text-truncate cursor-pointer" @click.stop="previewVideo(avatar)">Preview</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="card">
                        <div class="card-body">

                            <div class="mb-3 row">
                                <label class="col-md-3 col-form-label">Choose the layout</label>
                                <div class="col">
                                    <div class="btn-group w-100" role="group">
                                        <button class="btn w-50" @click="aspect = 'landscape'" :class="aspect === 'landscape' ? 'btn-outline-primary z-2' : ''">
                                            <div>
                                                <div>Landscape</div>
                                                <div :class="aspect === 'landscape' ? '' : 'text-secondary'">16:9</div>
                                            </div>
                                        </button>
                                        <button class="btn w-50" @click="aspect = 'portrait'" :class="aspect === 'portrait' ? 'btn-outline-primary z-2' : ''">
                                            <div>
                                                <div>Portrait</div>
                                                <div :class="aspect === 'portrait' ? '' : 'text-secondary'">9:16</div>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3 row">
                                <label class="col-md-3 col-form-label">Input method</label>
                                <div class="col">
                                    <div class="btn-group w-100" role="group">
                                        <button class="btn w-50" @click="inputType = 'type'" :class="inputType === 'type' ? 'btn-outline-primary z-2' : ''">
                                            <div>
                                                <div>Type text</div>
                                            </div>
                                        </button>
                                        <button class="btn w-50" @click="inputType = 'audio'" :class="inputType === 'audio' ? 'btn-outline-primary z-2' : ''">
                                            <div>
                                                <div>
                                                    Upload audio
                                                    <span :class="inputType === 'audio' ? '' : 'text-secondary'">.mp3</span>
                                                </div>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3 row" v-if="inputType == 'type'">
                                <label class="col-md-3 col-form-label"></label>
                                <div class="col">
                                    <textarea rows="3" class="form-control" placeholder="" v-model="text" maxlength="3500"></textarea>
                                    <div class="small text-secondary text-end mt-1">{{ text.length }} / 3500</div>
                                </div>
                            </div>

                            <div class="mb-3 row" v-if="inputType == 'type'">
                                <label class="col-md-3 col-form-label">Multilingual Voice</label>
                                <div class="col">
                                    <div class="btn-group d-flex" role="group">
                                        <label for="btn-radio-dropdown-dropdown" class="btn" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {{ selectedVoice ? selectedVoice.name : 'Select Multilingual Voice' }}
                                        </label>
                                        <div class="dropdown-menu" style="overflow: auto; max-height: 300px">
                                            <label class="dropdown-item" v-for="voice in filteredVoices" :key="voice.id" @click="selectedVoiceId = voice.id">{{voice.name}}</label>
                                        </div>
                                        <button class="btn avatar-preview-audio" :disabled="loading || !selectedVoice" @click="previewVoice">
                                            <icon icon="volume"></icon> Preview
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3 row" v-if="inputType == 'audio'">
                                <label class="col-md-3 col-form-label"></label>
                                <div class="col">
                                    <button v-if="!voiceFileName || !voiceFileDownloadUrl" @click="addVoiceFile" :disabled="loading" class="btn w-100">
                                        <icon icon="plus"></icon> Select or Upload File
                                    </button>
                                    <div v-else class="btn-group d-flex" role="group">
                                        <div class="btn btn-outline" :title="voiceFileName">{{ voiceFileName }}</div>
                                        <button class="btn avatar-preview-audio" :disabled="loading" @click="removeVoiceFile">
                                            <icon icon="close"></icon> Remove
                                        </button>
                                        <button class="btn avatar-preview-audio" :disabled="loading" @click="previewVoiceFile">
                                            <icon icon="volume"></icon> Preview
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3">
                                <AvatarPreview :aspect="aspect" :avatar="selectedAvatar" :background-type="backgroundType" :background-url="backgroundUrl" :position="position" :circle="circleBackground" @circleChange="circleBackground = $event"></AvatarPreview>
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" class="w-100" preserveAspectRatio="none" width="400" height="200" viewBox="0 0 400 200" fill="transparent" stroke="var(--tblr-border-color, #b8cef1)">
                                    <line x1="0" y1="0" x2="400" y2="200"></line>
                                    <line x1="0" y1="200" x2="400" y2="0"></line>
                                </svg> -->
                            </div>

                            <div v-if="selectedAvatar && ((selectedAvatar.categories && selectedAvatar.categories.setting.includes('Custom Background') && !backgroundCustomUrl) || getAvatarLooks(selectedAvatar).length > 1)" class="btn-group">
                                <div v-if="selectedAvatar && selectedAvatar.categories && selectedAvatar.categories.setting.includes('Custom Background') && !backgroundCustomUrl" class="d-flex" role="group">
                                    <label for="btn-radio-dropdown-dropdown" class="btn" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{ selectedBackground ? selectedBackground.name : 'Select Background' }}
                                    </label>
                                    <div class="dropdown-menu" style="overflow: auto; max-height: 300px">
                                        <label class="dropdown-item" v-for="background in backgrounds" :key="background.id" @click="selectedBackgroundId = background.id">{{background.name}}</label>
                                    </div>
                                </div>

                                <button v-if="selectedAvatar && selectedAvatar.categories && selectedAvatar.categories.setting.includes('Custom Background') && !backgroundCustomUrl" class="btn" @click="customBackground">Custom Background</button>
                                <button v-if="backgroundCustomUrl" class="btn" @click="removeCustomBackground">
                                    Remove Background
                                </button>
                              <button v-if="selectedAvatar && getAvatarLooks(selectedAvatar).length > 1" class="btn" @click="$refs['avatar-looks-modal'].open(selectedAvatarId, getAvatarLooks(selectedAvatar))">Change look</button>
                            </div>

                        </div>
                        <div class="card-footer text-end">
                            <button class="btn btn-primary" :disabled="loading" @click="generate">Generate Avatar AI video</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <agreement-modal />

    <avatar-looks-modal ref="avatar-looks-modal" @preview="previewVideo" @select="selectedAvatarId = $event" />
    <file-picker ref="background-picker-modal" :allowed-types="['video','image']" :allow-processing="false"></file-picker>
    <file-picker ref="voice-picker" :allowed-types="['audio', 'mp3', 'wav']" :allow-processing="false"></file-picker>

    <modal ref="video" @closed="preview = {}">
        <div class="modal-body p-0">
            <video v-if="preview && preview.video_preview_url" :src="preview.video_preview_url" class="w-100 d-block" controls autoplay></video>
            <div @click="$refs.video.close()" class="position-absolute cursor-pointer p-3" style="right: 0; top: 0;">
                <icon icon="close" height="30"></icon>
            </div>
        </div>
    </modal>
</div>

</template>

<script>
import api from "@/common/api";
import { loadSettings, saveSettings } from "@/utils/browser";
import AgreementModal from "@/components/local/AgreementModal.vue";
import AvatarLooksModal from "@/components/local/AvatarLooksModal.vue";
import FilePicker from "@/components/local/FilePicker.vue";
import AvatarPreview from "@/components/local/AvatarPreview.vue";

export default {
    components: {
        AgreementModal,
        AvatarLooksModal,
        FilePicker,
        AvatarPreview
    },
    data() {
        return {
            aspect: "landscape",
            inputType: "type",
            text: "",

            selectAvatarCardBodyOpen: window.innerWidth >= 992,

            mainOptions: ["All", "Professional", "Lifestyle", "AI-generated"], // "User-generated",
            orientationOptions: ["Landscape", "Portrait", "Square"],
            genderOptions: ["Woman", "Man"],
            ageOptions: ["Young Adult", "Middle Aged", "Elderly"],
            ethnicityOptions: ["White", "Black", "Asian", "South Asian", "Latino", "Middle Eastern"],
            styleOptions: ["Formal", "Casual", "Dress"],
            settingOptions: ["Outdoor", "Indoor", "Custom Background"],
            poseOptions: ["Standing", "Sitting"],
            occupationOptions: ["Education", "Business", "Medicine", "Government", "Artisan", "Service", "Construction", "Emergency Services", "Technology", "Sports"],

            searchQuery: "",

            main: [],
            orientation: [],
            gender: [],
            age: [],
            ethnicity: [],
            style: [],
            setting: [],
            pose: [],
            occupation: [],

            selectedAvatarId: null,
            selectedVoiceId: null,
            selectedBackgroundId: null,

            backgroundType: null,
            backgroundCustomUrl: null,

            avatars: [],
            voices: [],
            backgrounds: [],

            voicePreviewExec: false,
            voicePreviewScript: null,
            voicePreviewVoiceId: null,

            voiceFileName: null,
            voiceFileDownloadUrl: null,
            voicePreviewNeeded: false,

            position: {
                x: 0,
                y: 0,
                scale: 1
            },

            circleBackground: "",
            preview: {},

            loading: false,

            mobile: window.innerWidth < 992
        };
    },
    watch: {
        aspect(val) {
            saveSettings("create.aspect", val);
        },
        inputType(val) {
            saveSettings("create.inputType", val);
        },
        text(val) {
            saveSettings("create.text", val);
        },
        voiceFileName(val) {
            saveSettings("create.voiceFileName", val);
        },
        voiceFileDownloadUrl(val) {
            saveSettings("create.voiceFileDownloadUrl", val);
        },
        selectedAvatarId(val) {
            saveSettings("create.selectedAvatarId", val);
            if (this.selectedVoice && this.selectedVoice.gender !== this.avatars.find(a => a.id === val).gender) {
                this.selectedVoiceId = null;
            }
        },
        selectedVoiceId(val) {
            saveSettings("create.selectedVoiceId", val);
        },
        selectedBackgroundId(val) {
            saveSettings("create.selectedBackgroundId", val);
        },
        backgroundType(val) {
            saveSettings("create.backgroundType", val);
        },
        backgroundCustomUrl(val) {
            saveSettings("create.backgroundCustomUrl", val);
        }
    },
    computed: {
        selectedCategoryOptions() {
            return [
                ...this.main.map(o => ({ value: o, category: "main" })),
                ...this.orientation.map(o => ({ value: o, category: "orientation" })),
                ...this.gender.map(o => ({ value: o, category: "gender" })),
                ...this.age.map(o => ({ value: o, category: "age" })),
                ...this.ethnicity.map(o => ({ value: o, category: "ethnicity" })),
                ...this.style.map(o => ({ value: o, category: "style" })),
                ...this.setting.map(o => ({ value: o, category: "setting" })),
                ...this.pose.map(o => ({ value: o, category: "pose" })),
                ...this.occupation.map(o => ({ value: o, category: "occupation" }))
            ];
        },
        filteredAvatars() {
            const avatars = this.avatars.filter((a) => {
                const searchMatch = this.searchQuery ? JSON.stringify(a).toLocaleLowerCase().indexOf(this.searchQuery.toLocaleLowerCase()) > -1 : true;

                // If occupation is selected, show both parent and child avatars
                const parentMatch = !this.groupByParents() ? true : !a.parent_id;

                const mainMatch = this.main.length === 0 || (a.categories && a.categories.main && this.main.some(o => a.categories.main.includes(o)));
                const orientationMatch = this.orientation.length === 0 || (a.categories && a.categories.orientation && this.orientation.some(o => a.categories.orientation.includes(o)));
                const genderMatch = this.gender.length === 0 || (a.categories && a.categories.gender && this.gender.some(o => a.categories.gender.includes(o)));
                const ageMatch = this.age.length === 0 || (a.categories && a.categories.age && this.age.some(o => a.categories.age.includes(o)));
                const ethnicityMatch = this.ethnicity.length === 0 || (a.categories && a.categories.ethnicity && this.ethnicity.some(o => a.categories.ethnicity.includes(o)));
                const styleMatch = this.style.length === 0 || (a.categories && a.categories.style && this.style.some(o => a.categories.style.includes(o)));
                const settingMatch = this.setting.length === 0 || (a.categories && a.categories.setting && this.setting.some(o => a.categories.setting.includes(o)));
                const poseMatch = this.pose.length === 0 || (a.categories && a.categories.pose && this.pose.some(o => a.categories.pose.includes(o)));
                const occupationMatch = this.occupation.length === 0 || (a.categories && a.categories.occupation && this.occupation.some(o => a.categories.occupation.includes(o)));

                return searchMatch && parentMatch && mainMatch && orientationMatch && genderMatch && ageMatch && ethnicityMatch && styleMatch && settingMatch && poseMatch && occupationMatch;
            });
            avatars.sort((a, b) => {
                if (b.private && !a.private) return 1;
                if (a.private && !b.private) return -1;

                const aPro = a.categories && a.categories.main && a.categories.main.includes("Professional");
                const bPro = b.categories && b.categories.main && b.categories.main.includes("Professional");

                if (bPro && !aPro) return 1;
                if (aPro && !bPro) return -1;
                return 0;
            });
            return avatars;
        },
        filteredVoices() {
            if (!this.selectedAvatar) { return this.voices; }

            return this.voices.filter((a) => a.gender === this.selectedAvatar.gender);
        },
        selectedAvatar() {
            return this.avatars.find(a => a.id === this.selectedAvatarId);
        },
        selectedVoice() {
            return this.voices.find(a => a.id === this.selectedVoiceId);
        },
        selectedBackground() {
            return this.backgrounds.find(a => a.id === this.selectedBackgroundId);
        },
        backgroundUrl() {
            if (this.backgroundCustomUrl) {
                return this.backgroundCustomUrl;
            }
            const background = this.backgrounds.find(i => i.id === this.selectedBackgroundId);
            return background ? background.preview_url : null;
        }
    },
    async created() {
        await this.load();
        if (this.$route.query.duplication) {
            await this.loadConfigurationFromQueryParams();
        } else {
            await this.loadSavedConfiguration();
        }

        if (this.backgrounds.length > 1 && !this.selectedBackgroundId && !this.backgroundCustomUrl) {
            this.selectedBackgroundId = this.backgrounds[1].id;
            this.backgroundType = this.backgrounds[1].type ? this.backgrounds[1].type : null;
        }
    },
    mounted() {
        window.addEventListener("resize", this.checkIfMobile);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkIfMobile);
        if (this.voicePreviewExec) {
            this.voicePreviewExec.pause();
        }
    },
    methods: {
        removeCategoryOption(categoryOption) {
            this[categoryOption.category] = this[categoryOption.category].filter((o) => o !== categoryOption.value);
        },
        groupByParents() {
            /* if (this.occupation.length > 0) {
                return false;
            } */
            return true;
        },
        getAvatarLooks(avatar) {
            const parent = avatar.parent_id ? this.avatars.find(a => a.id === avatar.parent_id) : avatar;
            if (!this.groupByParents()) {
                return [];
            }
            return [parent, ...this.avatars.filter(a => a.parent_id === parent.id)];
        },
        checkIfMobile() {
            this.mobile = window.innerWidth < 992;
        },
        openSelectAvatarCardBody() {
            if (this.mobile) {
                this.selectAvatarCardBodyOpen = !this.selectAvatarCardBodyOpen;
            }
        },
        previewVoice() {
            // replay last
            if (this.voicePreviewScript === this.text && this.voicePreviewVoiceId === this.selectedVoiceId) {
                if (this.voicePreviewExec.paused) {
                    this.voicePreviewExec.play();
                } else {
                    this.voicePreviewExec.pause();
                }
                return;
            }

            // pause
            if (this.voicePreviewExec) {
                this.voicePreviewExec.pause();
            }

            this.voicePreviewNeeded = false;
            this.voicePreviewScript = this.text;
            this.voicePreviewVoiceId = this.selectedVoiceId;

            this.loading = true;
            api.avatarsPreviewVoice({ id: this.selectedVoiceId, text: this.text }).then(res => {
                if (res.audio) {
                    this.voicePreviewExec = new Audio("data:audio/mpeg;base64," + res.audio);
                    this.voicePreviewExec.play();
                }
            }).catch(e => {
                this.flashError(e);
            }).finally(() => {
                this.loading = false;
            });
        },
        addVoiceFile() {
            this.$refs["voice-picker"].open((sourceFile, close) => {
                close();
                this.voiceFileName = sourceFile.name;
                this.voiceFileDownloadUrl = sourceFile.download_url;
            });
        },
        removeVoiceFile() {
            this.voiceFileName = null;
            this.voiceFileDownloadUrl = null;
        },
        previewVoiceFile() {
            this.voicePreviewExec = new Audio(this.voiceFileDownloadUrl);
            this.voicePreviewExec.play();
        },
        customBackground() {
            this.$refs["background-picker-modal"].open((file, close) => {
                close();
                this.selectedBackgroundId = null;
                this.backgroundCustomUrl = file.download_url; // file.type
                this.backgroundType = file.type ? file.type : null;
            });
        },
        removeCustomBackground() {
            this.selectedBackgroundId = this.backgrounds.length > 1 ? this.backgrounds[1].id : null;
            this.backgroundCustomUrl = null;
            this.backgroundType = this.backgrounds.length > 1 && this.backgrounds[1].type ? this.backgrounds[1].type : null;
        },
        load() {
            return api.avatars().then(data => {
                this.avatars = data.avatars;
                this.voices = data.voices;
                this.backgrounds = data.backgrounds;
            }).catch(e => {
                this.flashError(e);
            }).finally(() => {
                this.$store.dispatch("credit/update");
            });
        },
        async loadSavedConfiguration() {
            await this.loadConfiguration({
                aspect: loadSettings("create.aspect"),
                inputType: loadSettings("create.inputType"),
                text: loadSettings("create.text"),
                voiceFileName: loadSettings("create.voiceFileName"),
                voiceFileDownloadUrl: loadSettings("create.voiceFileDownloadUrl"),
                selectedAvatarId: loadSettings("create.selectedAvatarId"),
                selectedVoiceId: loadSettings("create.selectedVoiceId"),
                selectedBackgroundId: loadSettings("create.selectedBackgroundId"),
                backgroundType: loadSettings("create.backgroundType"),
                backgroundCustomUrl: loadSettings("create.backgroundCustomUrl")
            });
        },
        async loadConfigurationFromQueryParams() {
            await this.loadConfiguration(this.$route.query);
        },
        async loadConfiguration(config) {
            this.aspect = config.aspect || "landscape";
            this.inputType = config.inputType || "type";
            this.text = config.text || "";
            this.voiceFileName = config.voiceFileName || null;
            this.voiceFileDownloadUrl = config.voiceFileDownloadUrl || null;
            await this.$nextTick();
            this.selectedAvatarId = config.selectedAvatarId || null;
            this.selectedVoiceId = config.selectedVoiceId || null;
            this.selectedBackgroundId = config.selectedBackgroundId || null;
            this.backgroundType = config.backgroundType || null;
            this.backgroundCustomUrl = config.backgroundCustomUrl || null;
        },
        generate() {
            const fileSuffix = this.text.substring(0, 35);

            if (this.inputType === "type") {
                if (!this.selectedVoice) {
                    this.flashError("Voice must be selected");
                    return;
                }
            }

            const name = (this.avatar && this.avatar.name ? this.avatar.name + " - " : "") + fileSuffix;

            const params = {
                avatar: this.selectedAvatar ? this.selectedAvatar.id : null,
                voice: this.inputType !== "type" ? "" : (this.selectedVoice ? this.selectedVoice.id : ""),
                script: this.inputType !== "type" ? this.voiceFileDownloadUrl : this.text,
                background: this.backgroundCustomUrl ? this.backgroundCustomUrl : (this.selectedBackground ? this.selectedBackground.id : ""),
                offset_x: this.position.x,
                offset_y: this.position.y,
                scale: this.position.scale,
                aspect: this.aspect,
                name,
                circle_background: this.circleBackground
            };

            this.loading = true;
            api.avatarsCreate(params).then((res) => {
                this.flashSuccess("Processing will begin shortly");
                this.$router.push({ name: "home" });
            }).catch(e => {
                this.loading = false;
                this.flashError(e);
            }).finally(() => {
            });
        },
        previewVideo(item) {
            this.$refs.video.open();
            this.preview = item;
        }
    }
};
</script>
<style>
.avatar-image {
  display: block;
  aspect-ratio: 1/1;
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.avatar-looks {
  left: 0.35rem;
  top: 0.35rem;
}

.avatar-name-and-preview-badges {
  max-width: calc(100% - 11px);
  right: 0.35rem;
  bottom: 0.35rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem;
}

.avatar-name-and-preview-badges .badge {
  max-width: 100%;
}

.avatar-preview-audio {
  width: auto;
  white-space: nowrap;
  flex: 0 1 auto !important;
}
</style>
